import React, { Component } from "react";
import {
  Row,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  Col,
  FormGroup,
  Label,
  Table,
  Input,
  Button,
  InputGroup,
  InputGroupAddon,
  Modal,
  ModalHeader,
  ModalBody,
  CustomInput,
  Spinner,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
import moment from "moment";
import DefaultImg from "../../assets/images/product/Default_img.jpg";
import Swal from "sweetalert2";

import {
  ChangeItemModelClose,
  itemHodApproval,
  MRitemHodApproval,
  MRISUserApproval,
  MRISHodApproval,
  //---------
  InputChangeValue,
  SelecteChangeValue,
  SelectedProducts,
  model_open,
  getAllProducts,
  getRowProducts,
  CProductImage,
  CProductChangeValue,
  CProductSelecteChangeValue,
  AddCustomProduct,
  SetParams,
  toggleTab,
  CPRightSidebar,
} from "../../store/MaterialRequest/actions";

class ChangeItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: 1,
    };

    this.ChangeHandeler = this.ChangeHandeler.bind(this);
    this.ChangeProduct = this.ChangeProduct.bind(this);
    this.CPChangeHandeler = this.CPChangeHandeler.bind(this);
    this.handleCustomProductSubmit = this.handleCustomProductSubmit.bind(this);
    this.openPage = this.openPage.bind(this);
    this.CPRightbar = this.CPRightbar.bind(this);
  }

  ChangeHandeler(e) {
    this.props.InputChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }
  handleSearch = (e) => {
    if (e.key === "Enter") {
      this.props.SetParams({
        ...this.props.params,
        search: e.target.value,
        page: 1,
      });
      this.props.getAllProducts(
        {
          ...this.props.params,
          search: e.target.value,
          page: 1,
        },
        true
      );
    }
  };
  autohandleSearch = (e) => {
    this.props.SetParams({
      ...this.props.params,
      search: e.target.value,
      page: 1,
    });
    if (e.target.value === "") {
      this.props.getAllProducts(
        {
          ...this.props.params,
          search: e.target.value,
          page: 1,
        },
        true
      );
    }
  };
  backtoList() {
    // this.addForm && this.addForm.reset();
    this.props.toggleTab(1);
  }
  ChangeProduct() {
    if (this.props.rowdata.qty !== null) {
      Swal.fire({
        title: "Are you sure Change Item?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Change it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.addForm && this.addForm.reset();

          var data = {
            mrstatus:
              this.props.MRlevel === "DeptHOD"
                ? 9
                : this.props.MRlevel === "MRHod"
                ? 10
                : this.props.MRlevel === "MRISUser"
                ? 11
                : 12,
            materialrequest_id:
              this.props.MRlevel === "MRISUser"
                ? this.props.changeItem.materialrequest_id
                : this.props.MRlevel === "MRISHod"
                ? this.props.changeItem.piimris[0].mritem.materialrequest_id
                : this.props.mrRowData.id,
            mritem_id:
              this.props.MRlevel === "MRISHod"
                ? this.props.changeItem.piimris[0].mritem.id
                : this.props.changeItem.id,
            t_product_id: this.props.productRowlist.id,
            t_qty: this.props.rowdata.qty,
            t_unit:
              this.props.rowdata?.unit_id == null
                ? this.props.productRowlist?.units[0].id
                : this.props.rowdata?.unit_id,

            t_make:
              this.props.rowdata.make == null
                ? this.props.changeItem.make
                : this.props.rowdata?.make,
            t_description:
              this.props.rowdata.description == null
                ? this.props.changeItem.description
                : this.props.rowdata?.description,
          };
          if (this.props.MRlevel === "DeptHOD") {
            this.props.itemHodApproval(data);
          } else if (this.props.MRlevel === "MRHod") {
            this.props.MRitemHodApproval(data);
          } else if (this.props.MRlevel === "MRISUser") {
            this.props.MRISUserApproval(data);
          } else {
            this.props.MRISHodApproval(data, this.props.PIData);
          }
          this.props.toggleTab(1);
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        text: "Place enter Quantity",
      });
    }
  }

  CPChangeHandeler(e) {
    this.props.CProductChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }
  ChangeCustomProduct() {
    var data = {
      mrstatus: 9,
      materialrequest_id: this.props.mrRowData.id,
      mritem_id: this.props.changeItem.id,
      t_product_id: this.props.changeCustomeItem.data.id,
      t_qty:
        this.props.cPRowData?.citem_qty == null
          ? this.props.changeItem.qty
          : this.props.cPRowData?.citem_qty,
      t_unit: this.props.changeCustomeItem.data.units[0].id,

      t_make:
        this.props.cPRowData?.cmake == null
          ? this.props.changeItem.make
          : this.props.cPRowData?.cmake,
      t_description:
        this.props.cPRowData?.cdescription == null
          ? this.props.changeItem.description
          : this.props.cPRowData?.cdescription,
    };

    this.props.itemHodApproval(data);
    this.props.toggleTab(1);
  }
  CustomProduct() {
    this.form && this.form.reset();
    this.props.toggleTab(3);
  }
  handleCustomProductSubmit() {
    var CustomProductData = {
      name:
        this.props.cPRowData?.name == null
          ? this.props.changeItem.product?.name
          : this.props.cPRowData?.name,
      department_id:
        this.props.cPRowData.department_id == null
          ? this.props.changeItem.department?.id
          : this.props.cPRowData.department_id,
      baseunit_id:
        this.props.cPRowData.baseunit_id == null
          ? this.props.changeItem?.product?.baseunit?.id
          : this.props.cPRowData.baseunit_id,
      units: [
        {
          name:
            this.props.cPRowData.baseunitLabel == null
              ? this.props.changeItem.unit?.name
              : this.props.cPRowData.baseunitLabel,
          units: 1,
        },
      ],
      cPimage: this.props.changeItem.product?.image,
    };

    this.props.AddCustomProduct({
      CustomProductData,
      cPimage: this.props.cPimage,
      FromReset: () => this.ChangeCustomProduct(),
    });
  }

  CPRightbar() {
    this.props.CPRightSidebar(this.props.changeItem);
  }
  handleImageChange(e) {
    if (e.target.files[0]) {
      let reader = new FileReader();
      let file = e.target.files[0];

      reader.onloadend = () => {
        this.props.CProductImage({
          file: file,
          imagePreviewUrl: reader.result,
        });
      };
      reader.readAsDataURL(file);
    }
  }
  openPage(pageNo) {
    this.props.SetParams({
      ...this.props.params,
      page: pageNo,
    });
    this.props.getAllProducts(
      {
        ...this.props.params,
        page: pageNo,
      },
      false
    );
  }
  handleScroll = (e) => {
    const target = e.target;
    if (target.scrollTop !== 0) {
      if (target.scrollHeight - target.scrollTop === target.clientHeight) {
        if (this.props.params.page <= this.props.params.no_of_pages) {
          this.openPage(this.props.params.page + 1);
        }
      }
    }
  };

  render() {
    console.log("changeItem", this.props.changeItem);
    var data = this.props.productslist;

    let { imagePreviewUrl } = this.props;

    let $imagePreview = null;
    if (imagePreviewUrl) {
      $imagePreview = (
        <img className="product-img" alt="User" src={imagePreviewUrl} />
      );
    } else {
      $imagePreview = (
        <img
          className="product-img"
          alt="User"
          src={
            this.props.changeItem?.product?.image == null
              ? imagePreviewUrl
              : this.props.changeItem?.product?.image
          }
        />
      );
    }

    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.Change_item_model}
          backdrop="static"
          centered
          size="lg"
        >
          <ModalHeader
            toggle={() => {
              this.props.ChangeItemModelClose();
              this.props.toggleTab(1);
            }}
          >
            Change Item
          </ModalHeader>
          <ModalBody className="pt-0 pb-2">
            <Row className="justify-content-center">
              <Col md={12}>
                <Row>
                  <Col lg={12}>
                    <Nav tabs className="nav-tabs-custom mb-2">
                      {(this.props.activeTab === 1 ||
                        this.props.activeTab === 2 ||
                        this.props.activeTab === 4) && (
                        <NavItem>
                          <NavLink
                            onClick={() => {
                              this.props.toggleTab(1);
                            }}
                            className={classnames(
                              { active: this.props.activeTab === 1 },
                              "pt-3 font-weight-bold card-title-16"
                            )}
                          >
                            {!this.props.activateproduct && (
                              <>
                                <span>
                                  Items List | {this.props.productsCount}
                                </span>
                              </>
                            )}
                          </NavLink>
                        </NavItem>
                      )}
                      {(this.props.activeTab === 2 ||
                        this.props.activeTab === 4) && (
                        <NavItem>
                          <NavLink
                            onClick={() => {
                              this.props.toggleTab(2);
                            }}
                            className={classnames(
                              { active: this.props.activeTab === 2 },
                              "pt-3 font-weight-bold card-title-16"
                            )}
                          >
                            Details
                          </NavLink>
                        </NavItem>
                      )}
                      {this.props.activeTab === 3 && (
                        <NavItem>
                          <NavLink
                            onClick={() => {
                              this.props.toggleTab(3);
                            }}
                            className={classnames(
                              { active: this.props.activeTab === 3 },
                              "pt-3 font-weight-bold card-title-16"
                            )}
                          >
                            Custom Item
                          </NavLink>
                        </NavItem>
                      )}
                      {(this.props.activeTab === 2 ||
                        this.props.activeTab === 4) && (
                        <NavItem>
                          <NavLink
                            onClick={() => {
                              this.props.toggleTab(4);
                            }}
                            className={classnames(
                              { active: this.props.activeTab === 4 },
                              "pt-3 font-weight-bold card-title-16"
                            )}
                          >
                            Units
                          </NavLink>
                        </NavItem>
                      )}
                    </Nav>
                    <TabContent activeTab={this.props.activeTab}>
                      <TabPane tabId={1}>
                        <div className="mt-2">
                          <FormGroup className="m-0">
                            <InputGroup>
                              <Input
                                type="text"
                                name="search"
                                className="form-control d-inline-block"
                                placeholder="Search Item"
                                value={this.props.params.search}
                                onChange={(e) => this.autohandleSearch(e)}
                                onKeyDown={(e) => this.handleSearch(e)}
                              />
                              <InputGroupAddon addonType="append">
                                {this.props.params.search !== "" && (
                                  <Button
                                    color="light"
                                    type="button"
                                    onClick={() => {
                                      this.props.SetParams({
                                        ...this.props.params,
                                        search: "",
                                        page: 1,
                                        // department:
                                        //   this.props.mrRowData.department_id,
                                      });
                                      this.props.getAllProducts(
                                        {
                                          search: "",
                                          page: 1,
                                          // department:
                                          //   this.props.mrRowData.department_id,
                                        },
                                        true
                                      );
                                    }}
                                  >
                                    <i className="text-danger ri-close-line"></i>
                                  </Button>
                                )}

                                <Button
                                  color="light"
                                  type="button"
                                  onClick={() => {
                                    this.props.getAllProducts(
                                      {
                                        search: this.props.params.search,
                                        page: 1,
                                        // department:
                                        //   this.props.mrRowData.department_id,
                                      },
                                      true
                                    );
                                  }}
                                >
                                  <i className="ri-search-line"></i> Search
                                </Button>
                              </InputGroupAddon>
                            </InputGroup>
                          </FormGroup>

                          {/* {this.props.dataLoading === true && (
                            <Spinner color="primary" />
                          )} */}
                        </div>

                        <div>
                          <div
                            className="table-responsive mt-2"
                            onScroll={this.handleScroll}
                            style={{
                              maxHeight: "450px",
                              overflowY: "auto",
                            }}
                          >
                            <Table className="table-centered mb-0">
                              <thead className="bg-light ">
                                <tr>
                                  <th style={{ width: "120px" }}>
                                    Item Images
                                  </th>
                                  <th style={{ width: "220px" }}>Item Name</th>
                                  <th style={{ width: "120px" }}>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.props.productsCount === 0 ? (
                                  <>
                                    {this.props.dataLoading === true ? (
                                      <tr className="text-center">
                                        <td colSpan="3">
                                          <Spinner color="primary" />
                                        </td>
                                      </tr>
                                    ) : (
                                      <tr className="text-center">
                                        <td colSpan="3">
                                          No Items Found.{" "}
                                          {this.props.MRlevel === "MRHod" && (
                                            <Link
                                              to="#"
                                              onClick={this.CPRightbar}
                                            >
                                              Add Product
                                            </Link>
                                          )}
                                          {this.props.MRlevel === "DeptHOD" && (
                                            <Link
                                              to="#"
                                              onClick={() => {
                                                this.CustomProduct();
                                              }}
                                            >
                                              Change Product
                                            </Link>
                                          )}
                                        </td>
                                      </tr>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {data.length === 0 ? (
                                      <>
                                        {this.props.dataLoading === true ? (
                                          <tr className="text-center">
                                            <td colSpan="3">
                                              <Spinner color="primary" />
                                            </td>
                                          </tr>
                                        ) : (
                                          <tr className="text-center">
                                            <td
                                              colSpan="3"
                                              className="text-danger"
                                            >
                                              Already item in the List
                                            </td>
                                          </tr>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {data?.map((product, key) => (
                                          <tr key={key}>
                                            <td className="nowrap ">
                                              <img
                                                src={
                                                  product.image == null
                                                    ? DefaultImg
                                                    : product.image
                                                }
                                                alt="product-img"
                                                title="product-img"
                                                className="avatar-sm"
                                              />
                                            </td>
                                            <td>
                                              <div className="font-size-12">
                                                {product.code === "nan"
                                                  ? "-"
                                                  : product.code}
                                              </div>
                                              <h5 className="mb-0 font-size-14 text-truncate">
                                                <Link
                                                  to="#"
                                                  className="text-dark"
                                                  onClick={() => {
                                                    this.props.toggleTab(2);
                                                    this.props.getRowProducts(
                                                      product.id
                                                    );
                                                  }}
                                                >
                                                  {product.name}
                                                </Link>
                                              </h5>
                                            </td>

                                            <td className="nowrap">
                                              <Button
                                                type="sudmit"
                                                color="primary"
                                                className="waves-effect waves-light mr-2"
                                                onClick={() => {
                                                  this.props.toggleTab(2);
                                                  this.props.getRowProducts(
                                                    product.id
                                                  );
                                                }}
                                              >
                                                <i className="mdi mdi-arrow-top-right mr-2"></i>
                                                Add
                                              </Button>
                                            </td>
                                          </tr>
                                        ))}
                                        {this.props.dataLoading === true && (
                                          <tr className="text-center">
                                            <td colSpan="3">
                                              <Spinner color="primary" />
                                            </td>
                                          </tr>
                                        )}
                                      </>
                                    )}
                                  </>
                                )}
                                {/* </>
                                )} */}
                              </tbody>
                            </Table>
                          </div>
                        </div>
                      </TabPane>
                      <TabPane tabId={2}>
                        <Row>
                          <Col md={5}>
                            <div className="product-detail text-center">
                              <img
                                src={
                                  this.props.productRowlist?.image == null
                                    ? DefaultImg
                                    : this.props.productRowlist?.image
                                }
                                alt="product-img"
                                title="product-img"
                                className="product-img  img-fluid mx-auto tab-img rounded"
                              />
                            </div>
                          </Col>
                          <Col md={7}>
                            <h5 className="mt-1 mb-1">
                              {this.props.productRowlist?.name}
                            </h5>
                            <div>
                              <p className="d-inline-block">
                                <span style={{ fontWeight: "bold" }}>
                                  Code :
                                </span>
                                <i>
                                  {this.props.productRowlist?.code === "nan"
                                    ? "***"
                                    : this.props.productRowlist?.code}
                                </i>
                              </p>
                              <p className="float-right d-inline-block mr-5">
                                <span style={{ fontWeight: "bold" }}>
                                  Section :
                                </span>
                                <i>
                                  {this.props.productRowlist?.section?.name}
                                </i>
                              </p>
                            </div>
                            <Row>
                              <Col md={12}>
                                <div className="Order-panel-content">
                                  <div className="list-column">
                                    <ul className="list-style-two p-0 product-desc-list">
                                      <li className="clearfix">
                                        <span className="ttl">
                                          <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                          Department :
                                        </span>
                                        <span className="dtl">
                                          {
                                            this.props.productRowlist
                                              ?.department.name
                                          }
                                        </span>
                                      </li>
                                      <li className="clearfix">
                                        <span className="ttl">
                                          <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                          Category :
                                        </span>
                                        <span className="dtl">
                                          {this.props.productRowlist?.category
                                            .name === "nan"
                                            ? "-"
                                            : this.props.productRowlist
                                                ?.category.name}
                                        </span>
                                      </li>
                                      <li className="clearfix">
                                        <span className="ttl">
                                          <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                          Product Group :
                                        </span>
                                        <span className="dtl">
                                          {
                                            this.props.productRowlist?.group
                                              .name
                                          }
                                        </span>
                                      </li>
                                      <li className="clearfix">
                                        <span className="ttl">
                                          <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                          Base Unit :
                                        </span>
                                        <span className="dtl">
                                          {
                                            this.props.productRowlist?.baseunit
                                              .name
                                          }
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                  <hr className="my-1" />
                                  <h6>Changed Item Details:</h6>
                                  <hr className="my-1" />
                                  <div className="list-column">
                                    <ul className="list-style-two p-0 product-desc-list">
                                      <li className="clearfix">
                                        <span className="ttl">
                                          <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                          Quantity :
                                        </span>
                                        <span className="dtl">
                                          {this.props.changeItem?.qty}{" "}
                                          {this.props.changeItem?.unit?.name}
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <hr className="my-1" />
                            <Col md={12}>
                              <AvForm
                                className="form-horizontal"
                                onValidSubmit={this.ChangeProduct}
                                ref={(c) => (this.addForm = c)}
                              >
                                <Row>
                                  <Col md={5}>
                                    <FormGroup>
                                      <Label htmlFor="item_qty">
                                        Quantity{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <AvField
                                        className="mb-0 form-control "
                                        min={0}
                                        // max={100}
                                        type="number"
                                        // step="1"
                                        name="qty"
                                        validate={{
                                          required: {
                                            value: true,
                                            errorMessage: "Please enter Qty",
                                          },
                                          pattern: {
                                            value:
                                              "^[0-9]{1,18}([.-]?)[0-9]{0,3}$",
                                            errorMessage:
                                              "Qty can compose numbers and 3 decimals ",
                                          },
                                        }}
                                        id="item_qty"
                                        value={this.props.rowdata?.qty}
                                        onChange={this.ChangeHandeler}
                                        placeholder="Qty"
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md={3}>
                                    <FormGroup>
                                      <Label htmlFor="units_select">
                                        Units
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <Select
                                        id="units_select"
                                        name="units_select"
                                        required="required"
                                        options={this.props.productRowlist?.units.map(
                                          (item) => ({
                                            label: item.name,
                                            value: item.id,
                                          })
                                        )}
                                        value={{
                                          label:
                                            this.props.rowdata?.unitsLabel ==
                                            null
                                              ? this.props.productRowlist
                                                  ?.units[0].name
                                              : this.props.rowdata?.unitsLabel,
                                          value:
                                            this.props.rowdata?.unit_id == null
                                              ? this.props.productRowlist
                                                  ?.units[0].id
                                              : this.props.rowdata?.unit_id,
                                        }}
                                        onChange={(e) => {
                                          this.props.SelecteChangeValue({
                                            key: "unitsLabel",
                                            label: e.label,
                                            key2: "unit_id",
                                            value: e.value,
                                          });
                                        }}
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md={4}>
                                    <FormGroup>
                                      <Label htmlFor="requiredDate">
                                        Required Date{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <AvField
                                        type="date"
                                        name="date"
                                        id="requiredDate"
                                        disabled={true}
                                        className="mb-0 form-control "
                                        placeholder="Select Date"
                                        value={
                                          this.props.MRlevel === "MRISUser"
                                            ? moment(
                                                this.props.changeItem.date
                                              ).format("YYYY-MM-DD")
                                            : moment(
                                                this.props.changeItem.date,
                                                "DD-MM-YYYY"
                                              ).format("YYYY-MM-DD")
                                        }
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md={5}>
                                    <FormGroup>
                                      <Label htmlFor="Make">
                                        Make{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <AvField
                                        type="textarea"
                                        name="make"
                                        id="Make"
                                        className="mb-0 form-control "
                                        placeholder="Add Make"
                                        value={
                                          this.props.rowdata?.make == null
                                            ? this.props.changeItem.make
                                            : this.props.rowdata?.make
                                        }
                                        onChange={this.ChangeHandeler}
                                        validate={{
                                          required: { value: true },
                                        }}
                                      />
                                    </FormGroup>
                                  </Col>

                                  <Col md={7}>
                                    <FormGroup>
                                      <Label htmlFor="Description">
                                        Description
                                      </Label>
                                      <AvField
                                        type="textarea"
                                        name="description"
                                        id="Description"
                                        className="mb-0 form-control "
                                        placeholder="Add Description"
                                        value={
                                          this.props.rowdata?.description ==
                                          null
                                            ? this.props.changeItem.description
                                            : this.props.rowdata?.description
                                        }
                                        onChange={this.ChangeHandeler}
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md={12}>
                                    <div className="float-right">
                                      <FormGroup>
                                        {!this.props.activateproduct && (
                                          <Button
                                            type="button"
                                            color="light "
                                            className="waves-effect waves-light d-inline-block mr-2"
                                            onClick={() => {
                                              this.backtoList();
                                            }}
                                          >
                                            Back To List
                                          </Button>
                                        )}

                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="waves-effect waves-light d-inline-block"
                                        >
                                          <i className="mdi mdi-plus mr-1"></i>
                                          Change Item
                                        </Button>
                                      </FormGroup>
                                    </div>
                                  </Col>
                                </Row>
                              </AvForm>
                            </Col>
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId={4}>
                        <Row>
                          <Col md={12}>
                            <div className="table-responsive table-bordered m-2">
                              <Table className="table-centered mb-0">
                                <thead className="bg-light ">
                                  <tr>
                                    <th style={{ width: "120px" }}>S.No</th>
                                    <th style={{ width: "220px" }}>
                                      Units Name
                                    </th>
                                    <th style={{ width: "120px" }}>Units</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.props.productRowlist?.units.map(
                                    (unit, key) => (
                                      <tr key={key}>
                                        <td className="nowrap ">{key + 1}</td>
                                        <td>{unit.name}</td>
                                        <td>{unit.units}</td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          </Col>
                          <Col>
                            <Button
                              type="button"
                              color="light"
                              className="waves-effect waves-light float-right mt-2"
                              onClick={() => {
                                this.props.toggleTab(2);
                              }}
                            >
                              Back To Product
                            </Button>
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId={3}>
                        <AvForm
                          className="form-horizontal"
                          onValidSubmit={this.handleCustomProductSubmit}
                          // ref={(c) => (this.form = c)}
                        >
                          <Row>
                            <Col md={5} lg={5}>
                              <div className="product-detail">
                                <div className="mt-2 align-items-center ">
                                  <label
                                    htmlFor="customItemFile"
                                    className="mt-4 text-center"
                                  >
                                    {$imagePreview}
                                  </label>

                                  <CustomInput
                                    type="file"
                                    className="file-upload"
                                    id="customItemFile"
                                    accept="image/*"
                                    multiple={false}
                                    onChange={(e) => this.handleImageChange(e)}
                                  />
                                </div>
                              </div>
                            </Col>
                            <Col md={7} lg={7}>
                              <Row>
                                <Col md={12}>
                                  <FormGroup className="mb-0">
                                    <Label
                                      htmlFor="CProduct-Name-text-input"
                                      className="col-form-label p-0"
                                    >
                                      Item Name
                                    </Label>

                                    <AvField
                                      className="mb-0 form-control "
                                      type="text"
                                      value={
                                        this.props.cPRowData?.name == null
                                          ? this.props.changeItem.product?.name
                                          : this.props.cPRowData?.name
                                      }
                                      onChange={this.CPChangeHandeler}
                                      id="CProduct-Name-text-input"
                                      name="name"
                                      placeholder="Product Name"
                                      validate={{
                                        required: { value: true },
                                      }}
                                    />
                                    <span className="text-danger mt-0">
                                      {this.props.error_msg?.name}
                                    </span>
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup className="mb-0">
                                    <Label
                                      htmlFor="CProduct-Quantity-text-input"
                                      className="col-form-label p-0"
                                    >
                                      Quantity
                                    </Label>

                                    <AvField
                                      className="mb-0 form-control "
                                      type="number"
                                      min={1}
                                      value={
                                        this.props.cPRowData?.citem_qty == null
                                          ? this.props.changeItem.qty
                                          : this.props.cPRowData?.citem_qty
                                      }
                                      onChange={this.CPChangeHandeler}
                                      id="CProduct-Quantity-text-input"
                                      name="citem_qty"
                                      placeholder="Quantity"
                                      validate={{
                                        required: { value: true },
                                      }}
                                    />
                                    {/* <span className="text-danger mt-0">
                                      {this.props.error_msg?.name}
                                    </span> */}
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label
                                      htmlFor="CProduct-Units-text-input"
                                      className="col-form-label p-0"
                                    >
                                      Units
                                    </Label>

                                    <Select
                                      id="basename"
                                      name="basename"
                                      classNamePrefix="select2-selection"
                                      options={this.props.BasicUnitlist.map(
                                        (item, index) => ({
                                          label: item.name,
                                          value: item.id,
                                        })
                                      )}
                                      value={{
                                        label:
                                          this.props.cPRowData.baseunitLabel ==
                                          null
                                            ? this.props.changeItem.unit?.name
                                            : this.props.cPRowData
                                                .baseunitLabel,
                                        value:
                                          this.props.cPRowData.baseunit_id ==
                                          null
                                            ? this.props.changeItem.unit?.id
                                            : this.props.cPRowData.baseunit_id,
                                      }}
                                      onChange={(e) => {
                                        this.props.CProductSelecteChangeValue({
                                          key: "baseunitLabel",
                                          label: e.label,
                                          key2: "baseunit_id",
                                          value: e.value,
                                        });
                                      }}
                                    />
                                    {/* <span className="text-danger mt-0">
                                      {this.props.error_msg?.baseunit_id}
                                    </span> */}
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label
                                      htmlFor="CProduct-Units-text-input"
                                      className="col-form-label p-0"
                                    >
                                      Deparment
                                    </Label>

                                    <Select
                                      id="Deparment"
                                      name="Deparment"
                                      classNamePrefix="select2-selection"
                                      options={this.props.deparmentslist.map(
                                        (item) => ({
                                          label: item.name,
                                          value: item.id,
                                        })
                                      )}
                                      value={{
                                        label:
                                          this.props.cPRowData
                                            .departmentLabel == null
                                            ? this.props.changeItem.department
                                                ?.name
                                            : this.props.cPRowData
                                                .departmentLabel,
                                        value:
                                          this.props.cPRowData.department_id ==
                                          null
                                            ? this.props.changeItem.department
                                                ?.id
                                            : this.props.cPRowData
                                                .department_id,
                                      }}
                                      onChange={(e) => {
                                        this.props.CProductSelecteChangeValue({
                                          key: "departmentLabel",
                                          label: e.label,
                                          key2: "department_id",
                                          value: e.value,
                                        });
                                      }}
                                    />
                                    {/* <span className="text-danger mt-0">
                                      {this.props.error_msg?.baseunit_id}
                                    </span> */}
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup className="mb-0">
                                    <Label
                                      htmlFor="CProduct-cdate-text-input"
                                      className="col-form-label p-0"
                                    >
                                      Required Date
                                    </Label>

                                    <AvField
                                      className="mb-0 form-control "
                                      type="date"
                                      min={moment(new Date()).format(
                                        "YYYY-MM-DD"
                                      )}
                                      value={
                                        this.props.cPRowData?.cdate == null
                                          ? moment(
                                              this.props.changeItem.date,
                                              "DD-MM-YYYY"
                                            ).format("YYYY-MM-DD")
                                          : this.props.cPRowData?.cdate
                                      }
                                      onChange={this.CPChangeHandeler}
                                      id="CProduct-cdate-text-input"
                                      name="cdate"
                                      placeholder="date"
                                      validate={{
                                        required: { value: true },
                                      }}
                                    />
                                    {/* <span className="text-danger mt-0">
                                      {this.props.error_msg?.name}
                                    </span> */}
                                  </FormGroup>
                                </Col>
                                <Col md={12}>
                                  <FormGroup className="mb-0">
                                    <Label
                                      htmlFor="CProduct-cmake-text-input"
                                      className="col-form-label p-0"
                                    >
                                      Make
                                    </Label>

                                    <AvField
                                      className="mb-0 form-control "
                                      type="text"
                                      value={
                                        this.props.cPRowData?.cmake == null
                                          ? this.props.changeItem.make
                                          : this.props.cPRowData?.cmake
                                      }
                                      onChange={this.CPChangeHandeler}
                                      id="CProduct-cmake-text-input"
                                      name="cmake"
                                      placeholder="Add Make"
                                      validate={{
                                        required: { value: true },
                                      }}
                                    />
                                    {/* <span className="text-danger mt-0">
                                      {this.props.error_msg?.name}
                                    </span> */}
                                  </FormGroup>
                                </Col>
                                <Col md={8}>
                                  <FormGroup className="mb-0">
                                    <Label
                                      htmlFor="CProduct-cdescription-text-input"
                                      className="col-form-label p-0"
                                    >
                                      Description
                                    </Label>

                                    <AvField
                                      className="mb-0 form-control "
                                      type="textarea"
                                      rows="4"
                                      value={
                                        this.props.cPRowData?.cdescription ==
                                        null
                                          ? this.props.changeItem.description
                                          : this.props.cPRowData?.cdescription
                                      }
                                      onChange={this.CPChangeHandeler}
                                      id="CProduct-cdescription-text-input"
                                      name="cdescription"
                                      placeholder="Add Description"
                                      validate={{
                                        required: { value: true },
                                      }}
                                    />
                                    {/* <span className="text-danger mt-0">
                                      {this.props.error_msg?.name}
                                    </span> */}
                                  </FormGroup>
                                </Col>
                                <Col md={4}>
                                  <div className="mt-4 ">
                                    <FormGroup className="mb-0">
                                      <Button
                                        block
                                        type="submit"
                                        color="primary"
                                        className="waves-effect waves-light d-inline-block  w-100"
                                        // onClick={() =>
                                        //   this.handleCustomProductSubmit()
                                        // }
                                      >
                                        <i className="mdi mdi-plus mr-1"></i>
                                        Add Item
                                      </Button>

                                      <Button
                                        block
                                        type="button"
                                        color="light"
                                        className="waves-effect waves-light d-inline-block mt-2 w-100"
                                        onClick={() => {
                                          this.props.toggleTab(1);
                                        }}
                                      >
                                        Cancel
                                      </Button>
                                    </FormGroup>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </AvForm>
                      </TabPane>
                    </TabContent>
                  </Col>
                </Row>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { BasicUnitlist, deparmentslist } = state.Mini;
  const {
    changeItem,
    PIData,
    changeCustomeItem,
    MRlevel,
    activateproduct,
    error_msg,
    activeTab,
    params,
    productslist,
    productsCount,
    dataLoading,
    productRowlist,
    productRowdata,
    cPRowData,
    cPimage,
    imagePreviewUrl,
    rowdata,
    mrRowData,
    Change_item_model,
    locId,
    deptId,
  } = state.Materialrequest;
  return {
    changeItem,
    PIData,
    changeCustomeItem,
    MRlevel,
    activateproduct,
    error_msg,
    activeTab,

    params,
    productslist,
    productsCount,
    dataLoading,
    productRowlist,
    productRowdata,
    BasicUnitlist,
    deparmentslist,
    cPRowData,
    cPimage,
    imagePreviewUrl,
    rowdata,
    mrRowData,
    Change_item_model,
    locId,
    deptId,
  };
};

export default connect(mapStatetoProps, {
  ChangeItemModelClose,
  itemHodApproval,
  MRitemHodApproval,
  MRISUserApproval,
  MRISHodApproval,
  InputChangeValue,
  SelecteChangeValue,
  getAllProducts,
  getRowProducts,
  SelectedProducts,
  model_open,
  CProductImage,
  CProductChangeValue,
  CProductSelecteChangeValue,
  AddCustomProduct,
  SetParams,
  toggleTab,
  CPRightSidebar,
})(ChangeItem);
